// 群的最原始定义信息
// 这张表貌似可以不需要
import { DB, ExecuteResult, SQLBatchTuple } from "./index";
import time from "../time";

const upsert_sql =
  "INSERT INTO t_group(" +
  " tid, uid, name, name_py, name_pys," +
  " admin_uids, cid, notice, notice_read, tag, tagid," +
  " ctime, lutime, lctime, avatar, scene," +
  " sceneid, flag, qrcode, qrcode_desc, group_check_switch," +
  " group_allow_member_list, group_allow_member_visit, group_friend_invite_enter," +
  " group_ban_chat, group_chat_interval_time, remark, " +
  "   group_sn, intro, group_member_alias," +
  " group_member_image, group_member_video,group_member_doc, group_member_quit_msg, join_notice, group_admin_special," +
  " member_count, member_synced" +
  ") VALUES (" +
  " ?, ?, ?, ?, ?," +      // tid, uid, name, name_py, name_pys
  " ?, ?, ?, ?, ?, ?," +   // admin_uids, cid, notice, notice_read, tag, tagid
  " ?, ?, ?, ?, ?," +      // ctime, lutime, lctime, avatar, scene
  " ?, ?, ?, ?, ?," +      // sceneid, flag, qrcode, qrcode_desc, group_check_switch
  " ?, ?, ?," +            // group_allow_member_list, group_allow_member_visit, group_friend_invite_enter
  " ?, ?, ?," +            // group_ban_chat, group_chat_interval_time, remark
  " ?, ?, ?," +            // group_sn, intro, group_member_alias
  " ?, ?, ?, ?, ?, ?," +          // group_member_image, group_member_video, group_member_quit_msg, join_notice, group_admin_special
  " ?, ?" +                    // member_count, member_synced
  ") ON CONFLICT(tid) DO UPDATE SET" +
  " uid = EXCLUDED.uid," +
  " name = EXCLUDED.name," +
  " name_py = EXCLUDED.name_py," +
  " name_pys = EXCLUDED.name_pys," +
  " admin_uids = EXCLUDED.admin_uids," +
  " cid = EXCLUDED.cid," +
  " notice = EXCLUDED.notice," +
  " notice_read = EXCLUDED.notice_read," +
  " tag = EXCLUDED.tag," +
  " tagid = EXCLUDED.tagid," +
  " ctime = EXCLUDED.ctime," +
  " lutime = EXCLUDED.lutime," +
  " lctime = EXCLUDED.lctime," +
  " avatar = EXCLUDED.avatar," +
  " scene = EXCLUDED.scene," +
  " sceneid = EXCLUDED.sceneid," +
  " flag = EXCLUDED.flag," +
  " qrcode = EXCLUDED.qrcode," +
  " qrcode_desc = EXCLUDED.qrcode_desc," +
  " group_check_switch = EXCLUDED.group_check_switch," +
  " group_allow_member_list = EXCLUDED.group_allow_member_list," +
  " group_allow_member_visit = EXCLUDED.group_allow_member_visit," +
  " group_friend_invite_enter = EXCLUDED.group_friend_invite_enter," +
  " group_ban_chat = EXCLUDED.group_ban_chat," +
  " group_chat_interval_time = EXCLUDED.group_chat_interval_time," +
  " remark = EXCLUDED.remark," +
  " group_sn = EXCLUDED.group_sn," +
  " intro = EXCLUDED.intro," +
  " group_member_alias = EXCLUDED.group_member_alias," +
  " group_member_image = EXCLUDED.group_member_image," +
  " group_member_video = EXCLUDED.group_member_video," +
  " group_member_doc = EXCLUDED.group_member_doc," +
  " group_member_quit_msg = EXCLUDED.group_member_quit_msg," +
  " join_notice = EXCLUDED.join_notice," +
  " group_admin_special = EXCLUDED.group_admin_special," +
  " member_count = EXCLUDED.member_count;";

export async function group_upsert(
  db: DB,
  group: Group
): Promise<ExecuteResult> {

  if (!group.flag) {
    group.flag = defaultGroup.flag;
  }
  if (!group.qrcode) {
    group.qrcode = defaultGroup.qrcode;
  }
  if (!group.qrcode_desc) {
    group.qrcode_desc = defaultGroup.qrcode_desc;
  }
  if (!group.group_check_switch) {
    group.group_check_switch = defaultGroup.group_check_switch;
  }
  if (!group.group_allow_member_list) {
    group.group_allow_member_list = defaultGroup.group_allow_member_list;
  }
  if (!group.group_allow_member_visit) {
    group.group_allow_member_visit = defaultGroup.group_allow_member_visit;
  }
  if (!group.group_friend_invite_enter) {
    group.group_friend_invite_enter = defaultGroup.group_friend_invite_enter;
  }
  if (!group.group_ban_chat) {
    group.group_ban_chat = defaultGroup.group_ban_chat;
  }
  if (!group.group_chat_interval_time) {
    group.group_chat_interval_time = defaultGroup.group_chat_interval_time;
  }
  if (!group.remark) {
    group.remark = defaultGroup.remark;
  }
  if (!group.group_member_alias) {
    group.group_member_alias = defaultGroup.group_member_alias;
  }
  if (!group.group_member_image) {
    group.group_member_image = defaultGroup.group_member_image;
  }

  if (!group.group_member_video) {
    group.group_member_video = defaultGroup.group_member_video;
  }

  if (!group.group_member_doc) {
    group.group_member_doc = defaultGroup.group_member_doc;
  }

  if (!group.group_member_quit_msg) {
    group.group_member_quit_msg = defaultGroup.group_member_quit_msg;
  }

  if (group.join_notice === undefined) {
    group.join_notice = defaultGroup.join_notice;
  }

  if (!group.group_admin_special) {
    group.group_admin_special = defaultGroup.group_admin_special;
  }

  if (!group.notice_read) {
    group.notice_read = defaultGroup.notice_read;
  }

  if (!group.group_sn) {
    group.group_sn = defaultGroup.group_sn;
  }

  if (!group.intro) {
    group.intro = defaultGroup.intro;
  }
  if (group.member_synced === undefined) {
    group.member_synced = defaultGroup.member_synced;
  }
  if (group.member_count === undefined) {
    group.member_count = defaultGroup.member_count;
  }

  const timeUNIX = time.toUnixMillSecond(time.now());
  const d = GroupToEntity(fixGroup(group));
  d.lutime = timeUNIX;
  d.lctime = timeUNIX;

  // 只需要传一遍参数（INSERT的参数）
  const params = [
    d.tid, d.uid, d.name, d.name_py, d.name_pys,
    d.admin_uids, d.cid, d.notice, d.notice_read, d.tag, d.tagid,
    d.ctime, d.lutime, d.lctime, d.avatar, d.scene,
    d.sceneid, d.flag, d.qrcode, d.qrcode_desc, d.group_check_switch,
    d.group_allow_member_list, d.group_allow_member_visit,
    d.group_friend_invite_enter, d.group_ban_chat, d.group_chat_interval_time,
    d.remark, d.group_sn, d.intro, d.group_member_alias, d.group_member_image,
    d.group_member_video,d.group_member_doc, d.group_member_quit_msg, d.join_notice, d.group_admin_special,
    d.member_count, d.member_synced
  ];

  return await db.Execute(upsert_sql, params);
}

/** 批量写入群信息 */
export async function group_batch_upsert(db: DB, groups: Group[]): Promise<{ error: any }> {
  const commands: SQLBatchTuple[] = [];
  const timeUNIX = time.toUnixMillSecond(time.now());
  for (const group of groups) {
    if (!group.flag) { group.flag = defaultGroup.flag; }
    if (!group.qrcode) { group.qrcode = defaultGroup.qrcode; }
    if (!group.qrcode_desc) { group.qrcode_desc = defaultGroup.qrcode_desc; }
    if (!group.group_check_switch) { group.group_check_switch = defaultGroup.group_check_switch; }
    if (!group.group_allow_member_list) { group.group_allow_member_list = defaultGroup.group_allow_member_list; }
    if (!group.group_allow_member_visit) { group.group_allow_member_visit = defaultGroup.group_allow_member_visit; }
    if (!group.group_friend_invite_enter) { group.group_friend_invite_enter = defaultGroup.group_friend_invite_enter; }
    if (!group.group_ban_chat) { group.group_ban_chat = defaultGroup.group_ban_chat; }
    if (!group.group_chat_interval_time) { group.group_chat_interval_time = defaultGroup.group_chat_interval_time; }
    if (!group.remark) { group.remark = defaultGroup.remark; }
    if (!group.group_member_alias) { group.group_member_alias = defaultGroup.group_member_alias; }
    if (!group.group_member_image) { group.group_member_image = defaultGroup.group_member_image; }
    if (!group.group_member_video) { group.group_member_video = defaultGroup.group_member_video; }
    if (!group.group_member_doc) { group.group_member_doc = defaultGroup.group_member_doc; }
    if (!group.group_member_quit_msg) { group.group_member_quit_msg = defaultGroup.group_member_quit_msg; }
    if (group.join_notice === undefined) { group.join_notice = defaultGroup.join_notice; }
    if (!group.group_admin_special) { group.group_admin_special = defaultGroup.group_admin_special; }
    if (!group.notice_read) { group.notice_read = defaultGroup.notice_read; }
    if (!group.group_sn) { group.group_sn = defaultGroup.group_sn; }
    if (!group.intro) { group.intro = defaultGroup.intro; }
    if (group.member_synced === undefined) { group.member_synced = defaultGroup.member_synced; }
    if (group.member_count === undefined) { group.member_count = defaultGroup.member_count; }

    const d = GroupToEntity(fixGroup(group));
    d.lutime = timeUNIX;
    d.lctime = timeUNIX;

    const params = [
      d.tid, d.uid, d.name, d.name_py, d.name_pys,
      d.admin_uids, d.cid, d.notice, d.notice_read, d.tag, d.tagid,
      d.ctime, d.lutime, d.lctime, d.avatar, d.scene,
      d.sceneid, d.flag, d.qrcode, d.qrcode_desc, d.group_check_switch,
      d.group_allow_member_list, d.group_allow_member_visit,
      d.group_friend_invite_enter, d.group_ban_chat, d.group_chat_interval_time,
      d.remark, d.group_sn, d.intro, d.group_member_alias, d.group_member_image,
      d.group_member_video,d.group_member_doc, d.group_member_quit_msg, d.join_notice, d.group_admin_special,
      d.member_count, d.member_synced
    ];
    commands.push([upsert_sql, params]);
  }
  if (commands.length === 0) return { error: null };
  const r = await db.BatchExecute(commands);
  return { error: 'group_batch_upsert error' };
}

export async function group_query_one(
  db: DB,
  tid: string
): Promise<{ error: any; group?: Group }> {
  const sql = `select * from t_group where tid= ? `;
  const r = await db.Query(sql, [tid]);
  if (r.error) {
    return { error: r.error };
  }
  if (!(r.data && r.data.length > 0)) {
    return { error: null };
  }
  const d = r.data[0] as Entity;
  return { error: null, group: EntityToGroup(d) };
}

export async function update_group_remark(db: DB, tid: string, remark: string) {
  const sql = `update t_group set remark = ? where tid= ?`;
  return await db.Execute(sql, [remark, tid])
}

/** 标记群成员数据已同步完整（进入聊天调 GetGroupDetail 成功后调用） */
export async function group_update_member_synced(db: DB, tid: string, memberCount: number) {
  const sql = `update t_group set member_synced = 1, member_count = ? where tid = ?`;
  return await db.Execute(sql, [memberCount, tid]);
}
function GroupToEntity(a: Group): Entity {
  return {
    tid: a.tid, // 会话Id
    uid: a.uid, // 创建人 群主
    name: a.name, // 群名
    name_py: a.namePY, // 群名 拼音
    name_pys: a.namePYS, // 群名 拼音首字母
    admin_uids: JSON.stringify(a.adminUids), // 群管理员
    cid: a.cid, // 客户端创建时填的id
    avatar: a.avatar,
    scene: a.scene,
    sceneid: a.sceneid,
    notice: a.notice, // 群公告
    notice_read: a.notice_read,
    tag: a.tag, // 群标签  0 - 内部群 1-企业群 2-供应商 3-服务商 4-供应链
    tagid: a.tagid, // 群标签  0 - 内部群 1-企业群 2-供应商 3-服务商 4-供应链
    ctime: a.ctime, // 创建时间

    flag: a.flag,    //0 - 默认正常 2 - 解散
    qrcode: a.qrcode,  //群二维码
    qrcode_desc: a.qrcode_desc,  //群二维码
    group_check_switch: a.group_check_switch,  //入群审核开关，1-需要审核，其余不用审核
    group_allow_member_list: a.group_allow_member_list,  //允许一般成员检视成员列表 1-允许，其余不能访问
    group_allow_member_visit: a.group_allow_member_visit,  //允许一般成员访问个人页面 1-允许访问，其余不能访问
    group_friend_invite_enter: a.group_friend_invite_enter,  //允许一般成员邀请好友入群 1-允许成员邀请入群，其余不容许
    group_ban_chat: a.group_ban_chat,            //全体禁言（仅限群主和管理员可发话）1-禁言，其余不禁言
    group_chat_interval_time: a.group_chat_interval_time,  //一般成员发话间隔设置,0-不间隔，1-表示间隔秒数
    group_member_alias: a.group_member_alias,  //成员修改群昵称,1-容许，其余不容许,默认不容许
    group_member_image: a.group_member_image,  //群成员发送图片,1-容许，其余不容许,默认不容许
    group_member_video: a.group_member_video,  //群成员发送视频,1-容许，其余不容许,默认不容许
    group_member_doc: a.group_member_doc,  //群成员发送文件,1-容许，其余不容许,默认不容许
    group_member_quit_msg: a.group_member_quit_msg,  //群成员退群消息,1-容许，其余不容许,默认不容许
    join_notice: a.join_notice, //群成员加入群消息,1-容许，其余不容许,默认不容许
    group_admin_special: a.group_admin_special,  //管理员和群主的发言字体可设置，"{"key":"value"}
    remark: a.remark,
    group_sn: a.group_sn, //群编号
    intro: a.intro, //群简介
    member_count: a.member_count, //群成员数量
    member_synced: a.member_synced, //群成员是否已同步

    lutime: a.lutime,
    lctime: a.lctime
  };
}

function EntityToGroup(a: Entity): Group {
  return {
    tid: a.tid, // 会话Id
    uid: a.uid, // 创建人 群主
    name: a.name, // 群名
    namePY: a.name_py, // 群名 拼音
    namePYS: a.name_pys, // 群名 拼音首字母
    adminUids: JSON.parse(a.admin_uids), // 群管理员
    cid: a.cid, // 客户端创建时填的id
    avatar: a.avatar,
    scene: a.scene,
    sceneid: a.sceneid,
    notice: a.notice, // 群公告
    notice_read: a.notice_read,//群公告是否已读 0 已读，其他未读
    tag: a.tag, // 群标签  0 - 内部群 1-企业群 2-供应商 3-服务商 4-供应链
    tagid: a.tagid, // 群标签  0 - 内部群 1-企业群 2-供应商 3-服务商 4-供应链
    ctime: a.ctime, // 创建时间

    flag: a.flag,    //0 - 默认正常 2 - 解散
    qrcode: a.qrcode,  //群二维码
    qrcode_desc: a.qrcode_desc,  //群二维码
    group_check_switch: a.group_check_switch,  //入群审核开关，1-需要审核，其余不用审核
    group_allow_member_list: a.group_allow_member_list,  //允许一般成员检视成员列表 1-允许，其余不能访问
    group_allow_member_visit: a.group_allow_member_visit,  //允许一般成员访问个人页面 1-允许访问，其余不能访问
    group_friend_invite_enter: a.group_friend_invite_enter,  //允许一般成员邀请好友入群 1-允许成员邀请入群，其余不容许
    group_ban_chat: a.group_ban_chat,            //全体禁言（仅限群主和管理员可发话）1-禁言，其余不禁言
    group_chat_interval_time: a.group_chat_interval_time,  //一般成员发话间隔设置,0-不间隔，1-表示间隔秒数

    group_member_alias: a.group_member_alias,  //成员修改群昵称,1-容许，其余不容许,默认不容许
    group_member_image: a.group_member_image,  //群成员发送图片,1-容许，其余不容许,默认不容许
    group_member_video: a.group_member_video,  //群成员发送视频,1-容许，其余不容许,默认不容许
    group_member_doc: a.group_member_doc,  //群成员发送文件,1-容许，其余不容许,默认不容许
    group_member_quit_msg: a.group_member_quit_msg,  //群成员退群消息,1-容许，其余不容许,默认不容许
    join_notice: a.join_notice, //群成员加入群消息, 1-容许，其余不容许,默认不容许
    group_admin_special: a.group_admin_special,  //管理员和群主的发言字体可设置，"{"key":"value"}
    remark: a.remark,  //一般成员发话间隔设置,0-不间隔，1-表示间隔秒数
    group_sn: a.group_sn, //群编号
    intro: a.intro, //群简介
    member_count: a.member_count, //群成员数量
    member_synced: a.member_synced, //群成员是否已同步

    lutime: a.lutime,
    lctime: a.lctime
  };
}

function fixGroup(a: Group): Group {
  return Object.assign({}, defaultGroup, a);
}

export type Group = {
  tid: string; // 会话Id
  uid: number; // 创建人 群主
  name: string; // 群名
  namePY: string; // 群名 拼音
  namePYS: string; // 群名 拼音首字母
  adminUids: number[]; // 群管理员
  cid: string; // 客户端创建时填的id
  avatar: string; // 头像
  scene: number; // 从哪里创建的，默认为0。 1-客服后台自动创建
  sceneid: string; // 场景关联的数据 企业群的话就是关联的企业appkey
  notice: string; // 群公告
  notice_read: string,//群公告是否已读 0已读 ，其他未读
  tag: string; // 群标签  0 - 内部群 1-企业群 2-供应商 3-服务商 4-供应链
  tagid: number; // 群标签  0 - 内部群 1-企业群 2-供应商 3-服务商 4-供应链
  ctime: number; // 创建时间

  flag: number;      //0 - 默认正常 2 - 解散
  qrcode: string;   //群二维码
  qrcode_desc: string;   //群二维码描述
  group_check_switch: string;  //入群审核开关，1-需要审核，其余不用审核
  group_allow_member_list: string;  //允许一般成员检视成员列表 1-允许，其余不能访问
  group_allow_member_visit: string;  //允许一般成员访问个人页面 1-允许访问，其余不能访问
  group_friend_invite_enter: string;  //允许一般成员邀请好友入群 1-允许成员邀请入群，其余不容许
  group_ban_chat: string;            //全体禁言（仅限群主和管理员可发话）1-禁言，其余不禁言
  group_chat_interval_time: string;  //一般成员发话间隔设置,0-不间隔，1-表示间隔秒数
  group_member_alias: string  //成员修改群昵称,1-容许，其余不容许,默认不容许
  group_member_image: string  //群成员发送图片,1-容许，其余不容许,默认不容许
  group_member_video: string  //群成员发送视频,1-容许，其余不容许,默认不容许
  group_member_doc: string  //群成员发送文件,1-容许，其余不容许,默认不容许
  group_member_quit_msg: string  //群成员退群消息,1-容许，其余不容许,默认不容许
  join_notice: number //群成员加入群消息,1-容许，其余不容许,默认不容许
  group_admin_special: string  //管理员和群主的发言字体可设置，"{"key":"value"}
  remark: string;  //群昵称
  group_sn: string; //群编号
  intro: string; //群简介
  member_count: number; //群成员数量（由 /v1/sdk/sync/group 接口返回）
  member_synced: number; //群成员是否已同步完整数据 0-未同步 1-已同步

  //本地
  lutime: number;
  lctime: number;
};

const defaultGroup: Group = {
  tid: "", // 会话Id
  uid: 0, // 创建人 群主
  name: "", // 群名
  namePY: "", // 群名 拼音
  namePYS: "", // 群名 拼音首字母
  adminUids: [], // 群管理员
  cid: "", // 客户端创建时填的id
  avatar: "", // 头像
  scene: 0,
  sceneid: "",
  notice: "", // 群公告
  notice_read: "",//群公告是否已读
  tag: "", // 群标签  0 - 内部群 1-企业群 2-供应商 3-服务商 4-供应链
  tagid: -1, // 群标签  0 - 内部群 1-企业群 2-供应商 3-服务商 4-供应链
  ctime: 0, // 创建时间

  flag: 0,    //0 - 默认正常 2 - 解散
  qrcode: "",  //群二维码
  qrcode_desc: "",  //群二维码
  group_check_switch: "",  //入群审核开关，1-需要审核，其余不用审核
  group_allow_member_list: "1",  //允许一般成员检视成员列表 1-允许，其余不能访问
  group_allow_member_visit: "1",  //允许一般成员访问个人页面 1-允许访问，其余不能访问
  group_friend_invite_enter: "1",  //允许一般成员邀请好友入群 1-允许成员邀请入群，其余不容许
  group_ban_chat: "",            //全体禁言（仅限群主和管理员可发话）1-禁言，其余不禁言
  group_chat_interval_time: "",  //一般成员发话间隔设置,0-不间隔，1-表示间隔秒数

  group_member_alias: "", //成员修改群昵称,1-容许，其余不容许,默认不容许
  group_member_image: "",  //群成员发送图片,1-容许，其余不容许,默认不容许
  group_member_video: "",  //群成员发送视频,1-容许，其余不容许,默认不容许
  group_member_doc: "",  //群成员发送文件,1-容许，其余不容许,默认不容许
  group_member_quit_msg: "",  //群成员退群消息,1-容许，其余不容许,默认不容许
  join_notice: 0, //群成员加入群消息,1-容许，其余不容许,默认不容许
  group_admin_special: "",  //管理员和群主的发言字体可设置，"{"key":"value"}
  remark: "",
  group_sn: "", //群编号
  intro: "", //群简介
  member_count: 0, //群成员数量
  member_synced: 0, //群成员是否已同步完整数据 0-未同步 1-已同步


  lutime: 0,
  lctime: 0
};

type Entity = {
  tid: string; // 会话Id
  uid: number; // 创建人 群主
  name: string; // 群名
  name_py: string; // 群名 拼音
  name_pys: string; // 群名 拼音首字母
  admin_uids: string; // 群管理员
  cid: string; // 客户端创建时填的id
  avatar: string; // 头像
  scene: number;
  sceneid: string;
  notice: string; // 群公告
  notice_read: string,//群公告是否已读 0 已读，其他未读
  tag: string; // 群标签  0 - 内部群 1-企业群 2-供应商 3-服务商 4-供应链
  tagid: number; // 群标签  0 - 内部群 1-企业群 2-供应商 3-服务商 4-供应链
  ctime: number; // 创建时间

  flag: number;   //0 - 默认正常 2 - 解散
  qrcode: string;  //群二维码
  qrcode_desc: string;  //群二维码
  group_check_switch: string;  //入群审核开关，1-需要审核，其余不用审核
  group_allow_member_list: string;  //允许一般成员检视成员列表 1-允许，其余不能访问
  group_allow_member_visit: string;  //允许一般成员访问个人页面 1-允许访问，其余不能访问
  group_friend_invite_enter: string;  //允许一般成员邀请好友入群 1-允许成员邀请入群，其余不容许
  group_ban_chat: string;           //全体禁言（仅限群主和管理员可发话）1-禁言，其余不禁言
  group_chat_interval_time: string;  //一般成员发话间隔设置,0-不间隔，1-表示间隔秒数
  group_member_alias: string  //成员修改群昵称,1-容许，其余不容许,默认不容许
  group_member_image: string  //群成员发送图片,1-容许，其余不容许,默认不容许
  group_member_video: string  //群成员发送视频,1-容许，其余不容许,默认不容许
  group_member_doc: string  //群成员发送文件,1-容许，其余不容许,默认不容许
  group_member_quit_msg: string  //群成员退群消息,1-容许，其余不容许,默认不容许
  join_notice: number; //群成员加入群消息,1-容许，其余不容许,默认不容许
  group_admin_special: string  //管理员和群主的发言字体可设置，"{"key":"value"}
  remark: string;  //群昵称
  group_sn: string; //群编号
  intro: string; //群简介
  member_count: number; //群成员数量
  member_synced: number; //群成员是否已同步

  //本地
  lutime: number;
  lctime: number;
};
